import StreamsDetails from './StreamsDetails';

export default StreamsDetails;
